import React, { useEffect, useState } from 'react'
import { canAccessRequests } from 'utils/access'
import { emptyRequestCounts, getPendingRequestCounts } from 'service/RequestCountsService'
import { REQUEST_COUNTS_CHANGED } from 'service/RequestCountEvents'
import { RequestCountsContext } from '../RequestCountsContext'

export default function RequestCountsProvider({ user, children }) {
  const [counts, setCounts] = useState(emptyRequestCounts)
  useEffect(() => {
    let active = true
    let sequence = 0
    setCounts(emptyRequestCounts())
    if (!canAccessRequests(user) || user.is_report_only) return
    const refresh = async () => {
      const current = ++sequence
      try {
        const result = await getPendingRequestCounts(user)
        if (active && current === sequence) setCounts(result)
      } catch {
        if (active && current === sequence) setCounts(emptyRequestCounts())
      }
    }
    refresh()
    const timer = setInterval(() => {
      if (document.visibilityState !== 'hidden') refresh()
    }, 30000)
    window.addEventListener('focus', refresh)
    window.addEventListener(REQUEST_COUNTS_CHANGED, refresh)
    return () => {
      active = false
      clearInterval(timer)
      window.removeEventListener('focus', refresh)
      window.removeEventListener(REQUEST_COUNTS_CHANGED, refresh)
    }
  }, [user])
  return <RequestCountsContext.Provider value={counts}>{children}</RequestCountsContext.Provider>
}
